export const channelTip = {
  title: "Canal",
  description:
    "É a estratégia utilizada para prospectar talentos. De onde veio o talento, como chegamos até ele. Ex: Base, prospecção no linkedin, comunidades, growth...",
};

export const sourceTip = {
  title: "Source",
  description:
    "Trata-se da plataforma pela qual o tráfego é originado. Ex: linkedin, huggy, telegram, facebook...",
};

export const mediumTip = {
  title: "Medium",
  description:
    "É identificação da ferramenta usada. Caso não encontre um medium adequado, você pode adicionar um novo. Ex: Nome da comunidade, handpick.",
};

export const contentTip = {
  title: "Content",
  description:
    "O Content é a forma de identificar uma copy dentro de um canal. EX: copy-1, copy-feed...",
};

export const customUrlTip = {
  title: "URL customizada",
  description:
    "Para customizar a URL encurtada. Escolhendo o que virá depois da barra: 'byintera.in/customizada'.",
};

export const byinteraInBtnTip = {
  title: "Gera os encurtadores byintera.in e vagas-emb",
};

export const bitlyBtnTip = {
  title: "Gera o encurtador bit.ly",
};

export const bitlyTip = {
  title: "Bit.ly",
  description:
    "Use esse encurtador em qualquer canal, exceto no chat do LinkedIn. Para mais informações, veja o Manual de UTM.",
};

export const byinteraInTip = {
  title: "Byintera.in",
  description:
    "Use esse encurtador em qualquer canal, exceto no chat do LinkedIn. Para mais informações, veja o Manual de UTM.",
};

export const vagasEmbTip = {
  title: "Vagas-emb",
  description:
    "Use esse encurtador no chat do LinkedIn para não gerar um preview da vaga. Para mais informações, veja o Manual de UTM.",
};
